import {customerTypeEnum} from '../CellcomAbroadLobbyBlock/cellcomAbroadVariables';

export const reportDWHBuilder = (mode, params, props) => {
  const {data, portalState, userData} = props;
  const {validatedCostumerData} = data?.otpData || {};
  const isBusiness = validatedCostumerData?.accountType === customerTypeEnum.BUSINESS || data?.epiStyleInitializationData.businessIndividualLobby || null;

  const defaultReport = {
    area: 'SelfCare',
    subArea: 'BusinessBrowsingData',
    actionType: '',
    messageText: '',
    status: '',
    param1: portalState.selectedHetPay ?? '',
    param9: userData?.loginData?.userDetails?.IDNumber ?? '',
    param10: portalState?.customerPhoneNumber ?? '',
    customerName: `${portalState?.firstName} ${portalState?.lastName}` ?? '',
    idNumber: params?.idNumber ?? '',
    subscriber: userData?.selectedSubscriber ?? '',
    crmId: params?.crmId ?? ''
  };

  const reports = {
    DISPLAY_SEARCH_PAGE: {
      actionType: 'Browsing data subscription search page',
      status: 'Ongoing',
      messageText: 'Subscriber Search Page Displayed'
    },
    SEARCH_BTN_CLICK: {
      actionType: 'Browsing data subscription search page',
      status: 'Ongoing',
      messageText: 'Subscriber Search Page Button Clicked'
    },
    SUB_NOT_FOUND: {
      actionType: 'Browsing data subscription search page',
      status: 'Completed',
      messageText: 'Subscriber Not Found'
    },
    SEARCH_GEN_ERR: {
      actionType: 'Browsing data subscription search page',
      status: 'Error',
      messageText: 'General Error'
    },
    SUB_DIFF_ORG: {
      actionType: 'Subscriber associated with another business account',
      status: 'Ongoing',
      messageText: 'Subscriber associated with another business account'
    },
    DISPLAY_DATA: {
      actionType: 'Browsing data Package details page',
      status: 'Completed',
      messageText: 'Subscriber Package details page Displayed'
    },
    PURCHASE_BTN_CLICKED: {
      actionType: 'Browsing data Package details page',
      status: 'Ongoing',
      messageText: 'Subscriber pressed  page Displayed'
    },
    ANOTHER_SUB: {
      actionType: 'Browsing data Package details page',
      status: 'Ongoing',
      messageText: 'Subscribe Click  to purchase a browsing extension'
    },
    PACKAGES_DISPLAYED: {
      actionType: 'Browsing data Browsing extension',
      status: 'Ongoing',
      messageText: 'Subscribe browsing extension page Displayed'
    },
    GEN_ERR: {
      actionType: 'Browsing data Browsing extension',
      status: 'Error',
      messageText: 'General Error'
    },
    PURCHASE_SUCCESS: {
      actionType: 'Browsing data Browsing extension',
      status: 'Completed',
      messageText: 'Success'
    }
  };

  const report = reports[mode] || {};
  return {...defaultReport, ...report};
};
